<template>
  <div class="list-box">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRenYuanList"
      data-title="发票管理"
    >
      <el-segmented
        v-model="state.params.status"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        :options="[{ Text: '全部' }, ...$base.Invoice_Status]"
        :empty-values="[null, undefined, 0]"
        class="c-segmented"
        @change="onLoad"
      />
    </div>
    <div class="flex flex-wrap gap-x-5 mt-2 gap-y-2">
      <el-input
        v-model="state.params.keywords"
        class="!w-72"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <c_cell title="开票日期">
        <el-date-picker
          v-model="state.invoice_date"
          type="daterange"
          range-separator="至"
          value-format="YYYY-MM-DD"
        />
      </c_cell>
      <c_cell title="到款日期">
        <el-date-picker
          v-model="state.receipt_date"
          type="daterange"
          range-separator="至"
          value-format="YYYY-MM-DD"
        />
      </c_cell>
      <div class="flex flex-1">
        <el-button type="primary" icon="Search" @click="onLoad()">
          查询
        </el-button>
        <el-button type="info" link icon="Refresh" @click="onReset()">
          重置
        </el-button>
      </div>
      <c_cell title="开票金额合计">
        <template #default>
          <c_statistics
            :key="state.amountStatistic?.totalAmount"
            :value="state.amountStatistic?.totalAmount"
            color="#ffa500"
            :prefix="false"
            bold
            :size="16"
          />
        </template>
      </c_cell>
      <el-button type="primary" link @click="onExport" icon="Download">
        导出
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="状态" label2="类型" />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <c_status
                  arrName="Meeting_Invoice_Status"
                  :value="row.status"
                  :key="row.status"
                />
              </template>
              <template #bottom>
                <c_status
                  arrName="Invoice_Type"
                  :value="row.invoice_type"
                  :key="row.invoice_type"
                />
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              class="c-table-col-header"
              label1="发票抬头"
              label2="纳税人识别号"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.invoice_title" :value2="row.tax_no" />
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="会议名称" label2="地址" />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.meeting?.name"
              :value2="row.meeting?.address"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="amount"
          label="开票金额"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="发票号" label2="开票日期" />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.invoice_no || '-'"
              :value2="row.invoice_date || ''"
            />
          </template>
        </el-table-column>
        <el-table-column label="创建信息">
          <template #default="{ row }">
            <c_tabgroup :value2="row.create_time">
              <template #top>
                <text>
                  {{ row.add_admin_name }}
                </text>
                <text class="text-xs text-gray-400">
                  {{ "/" + row.add_department_name }}
                </text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Select"
              link
              @click.stop="
                state.selectId = row.id;
                state.from = 'kaipiao';
                state.showDetail = true;
              "
              v-if="$base.btn_status?.发票管理?.开票?.includes(row.status)"
              >开票
            </el-button>
            <el-button
              type="primary"
              :icon="EditPen"
              link
              @click.stop="
                state.selectId = row.id;
                state.from = 'daokuan';
                state.showDetail = true;
              "
              v-else-if="
                $base.btn_status?.发票管理?.标记到款?.includes(row.status)
              "
              >标记到款
            </el-button>
            <el-button
              type="success"
              :icon="SemiSelect"
              link
              @click.stop="
                state.selectId = row.id;
                state.from = 'hongchong';
                state.showDetail = true;
              "
              v-else-if="$base.btn_status?.发票管理?.红冲?.includes(row.status)"
              >红冲
            </el-button>
            <el-button
              type="success"
              :icon="Search"
              link
              @click.stop="
                state.selectId = row.id;
                state.from = 'chakan';
                state.showDetail = true;
              "
              v-else
              >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showDetail"
    title="发票审批"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
  >
    <c_detail
      :id="state.selectId"
      :from="state.from"
      @close="
        state.showDetail = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { invoice_page, invoice_export } from "@/http/invoice";
import { funcExport } from "@/utils/funcs";

import c_detail from "./Detail";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_detail,
  },
  props: {
    params: Number,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      if (state.invoice_date?.length == 2) {
        state.params.invoice_date = state.invoice_date.join(" ~ ");
      }

      if (state.receipt_date?.length == 2) {
        state.params.receipt_date = state.receipt_date.join(" ~ ");
      }

      invoice_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count, amountStatistic } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
          state.amountStatistic = amountStatistic;
        }
      });
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      delete state.invoice_date;
      delete state.receipt_date;
      onLoad();
    };

    const onExport = () => {
      let data = {
        ...state.params,
      };
      data.page = 1;
      data.limit = 0;

      if (state.invoice_date?.length == 2) {
        data.invoice_date = state.invoice_date.join(" ~ ");
      }

      if (state.receipt_date?.length == 2) {
        data.receipt_date = state.receipt_date.join(" ~ ");
      }

      funcExport(invoice_export, data);
    };

    return { state, props, onLoad, onExport, onReset };
  },
};
</script>

<style lang="less" scoped></style>
